// extracted by mini-css-extract-plugin
module.exports = {"checkBoxLabel":"Styles_checkBoxLabel__3Q9QS","activeCheckBox":"Styles_activeCheckBox__2JFvm","simpleTable":"Styles_simpleTable__2H72c"};